import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DirectorioService } from '../../login/services/directorio.service';
import { AdminServiceService } from 'src/app/admin/service/admin-service.service';
import { FileService } from 'src/app/services/file.service';
import { FormServices } from '../../services/form-services';
import { UiService } from 'src/app/admin/service/ui.service';

@Component({
  selector: 'app-pasarela-gateway',
  templateUrl: './pasarela.component.html',
  styleUrls: ['./pasarela.component.scss'],
})
export class PasarelaComponent implements OnInit {
  @Input() showStore = true;
  public pasarelaGroup: UntypedFormGroup = undefined;
  public display = false;
  public controls = [
    { 
      name: 'type', 
      label: 'Tipo', 
      type: 'select', 
      options: [
        {
          label: 'Paypal',
          value: 'Paypal'
        },
        {
          label: 'Stripe',
          value: 'Stripe'
        }
      ] 
    },
    { name: 'name', label: 'Nombre', type: 'text', placeholder: 'Nombre a mostrar' },
    { name: 'key', label: 'Public key', type: 'text', placeholder: 'ABCD123' },
    { name: 'secretKey', label: 'Secret Key (STRIPE)', type: 'text', placeholder: 'ABCD123', hidden: true },
    { name: 'storeId', label: 'Tienda', type: 'select', options: [], hidden: false },
  ]
  public createdDirectives = [];
  public id = undefined;
  private _savedForm = undefined;

  constructor(
    private fb: UntypedFormBuilder,
    private directorioService: DirectorioService,
    private adminSv: AdminServiceService,
    private fileSv: FileService,
    private formSv: FormServices,
    private uiSv: UiService
  ) { }

  async ngOnInit() {
    console.log('this.showStore :>> ', this.showStore);
    if(!this.showStore){
      const storeInput = this.controls.find(x => x.name === 'storeId');
      storeInput.hidden = true;
    }
    console.log('this.controls :>> ', this.controls);
    await this.getShops();
    this.pasarelaGroup = this.fb.group({
      name: ['', [Validators.required]],
      type: ['', [Validators.required]],
      key: ['', [Validators.required]],
      secretKey: [{value: '', disabled: true}, [Validators.required]],
      storeId: [{value: '', disabled: !this.showStore}, [Validators.required]],
    })
  }

  setType(ev){
    const type = ev.detail.value;
    if(!Number(type)){
      if(type === 'Stripe'){
        console.log(type);
        const serverKey = this.controls.find(x => x.name === 'secretKey')
        serverKey.hidden = false;
        this.pasarelaGroup.get('secretKey').enable();
      } else {
        this.pasarelaGroup.get('secretKey').disable();
        const serverKey = this.controls.find(x => x.name === 'secretKey')
        serverKey.hidden = true;
      }
    }

  }

  async getShops() {
    return new Promise((resolve, reject) => {
      this.directorioService.getDirectives().subscribe((res: any) => {
        const data = [
          ...res.data.filter((directives) => directives.id_plan),
        ];
        this.createdDirectives = data.map(store => {
          return {
            label: store.business_name,
            value: store.id
          }
        })
        const storeBtn = this.controls.find(x => x.name === 'storeId');
        storeBtn.options = this.createdDirectives;
        resolve(true);
      });
    });
  }

  async save(){
    const action = this.id ? 'update' : 'store';
    this.pasarelaGroup.value.id = this.id;
    await this.uiSv.presentLoader();
    await this.adminSv.post(this.pasarelaGroup.value, 'paymentGateway', action);
    await this.uiSv.loading.dismiss();
    this.uiSv.showToast('Operación realizada con éxito');
    this.id = undefined;
    this.pasarelaGroup.reset();
    this.formSv.deleteListProductSrc.next('reloadListProduct');
  }

  async edit({ product, action, changeAction }){
    try{
      const { id, savedForm } = await this.fileSv.getProduct(
        { product, action, changeAction }, 
        this.id, 
        'paymentGateway', 
        'Pasarela', 
        this._savedForm
      );
      console.log(id);
      this.id = id;
      this._savedForm = undefined;
      if(action !== 'delete'){
        (savedForm && savedForm.existence === null) ? savedForm.existenceNull = false : savedForm.existenceNull = true;
        setTimeout(() => {
          if(savedForm.video === 'null'){
            savedForm.video = null;
          }
          this._savedForm = savedForm;
          this.pasarelaGroup.patchValue(savedForm);
        }, 1)
      }
      this.showFilter();
    }catch(err){
      console.error(err);
    }
  }

  showFilter(){
    this.display = !this.display;
  }
}
